import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

const { version } = require('../../package.json')

export default () => {
  Bugsnag.start({
    apiKey: "64fb2a40e337179031d2195e3ef07f94",
    plugins: [new BugsnagPluginVue()],
    appVersion: version
  });
};
